var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "moon icon-new icon-filter #C8C8C8",
    width: "20px",
    height: "20px",
    viewBox: "0 0 1408 1024",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 109.714c0-55.545 45.027-100.571 100.571-100.571h1206.858c55.543 0 100.571 45.027 100.571 100.571s-45.029 100.571-100.571 100.571h-1206.858c-55.545 0-100.571-45.027-100.571-100.571zM268.19 512c0-55.545 45.027-100.571 100.571-100.571h670.476c55.543 0 100.571 45.027 100.571 100.571s-45.029 100.571-100.571 100.571h-670.476c-55.545 0-100.571-45.027-100.571-100.571zM569.905 813.714c-55.545 0-100.571 45.029-100.571 100.571s45.027 100.571 100.571 100.571h268.19c55.543 0 100.571-45.029 100.571-100.571s-45.029-100.571-100.571-100.571h-268.19z",
    style: {
      fill: "rgb(200, 200, 200)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.208f24a39a93a274de324c6ecc36d99a.svg";
export { ForwardRef as ReactComponent };